/* ------------------------------------------------
自定义组件
--------------------------------------------------*/
import { Debonce, ScrollTracker } from '@xbuilder/helper';  // helper组件
import { MainMenuManager } from '@xbuilder/xc2/style1';
new MainMenuManager({
    breakpoint:window.desktop_to_mobile  // 菜单切换断点
});
import {TabSwitcher} from "@xbuilder/xc10"; // 选项卡切换组件
import {DialogManager} from "@xbuilder/xc6"; // 语言切换组件
import {FloatBar} from '@xbuilder/floatbar';  // 引入侧边栏悬浮组件
// swiper
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
$(function(){
    new TabSwitcher(); // 选项卡切换组件
    new DialogManager();   // 初始化弹窗组件
    const floatbar = new FloatBar();  //实例化悬浮组件
    // 首页swiper
    const homeSwiper = new Swiper('.home-swiper', {
        speed: 1000,
        loop: true,
        // autoplay: {
        //     delay: 5000,
        //     disableOnInteraction: false
        // },
        pagination: {
            el: '.home-swiper-pagination',
            clickable: true,
            renderBullet: function (index, className) {
                return `
                <span class="${className}">
                <svg width="30" height="30" viewBox="0 0 100 100">
                    <circle class="circle" cx="50" cy="50" r="45" stroke="#fff" stroke-width="6" fill="none" stroke-dasharray="282.7" stroke-dashoffset="282.7" />
                    <circle cx="50" cy="50" r="15" fill="#fff" />
                </svg>
                </span>`
            },
        }
    });

    const enviromentSwiper = new Swiper('.enviroment-swiper', {
        speed: 1000,
        loop: true,
        slidesPerView: 1,
        breakpoints: {
            768: {
                slidesPerView: 'auto',
            },
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },

    });
})